import { ajax } from 'rxjs/observable/dom/ajax';
import isPlainObject from 'lodash/isPlainObject';
import isNumber from 'lodash/isNumber';
import queryString from 'query-string';
import JWT from './jwt';
import AppError from './AppError';
import {
  AJAX_RETRY_DELAY,
  AJAX_RETRY_LIMIT,
  AJAX_TIMEOUT,
  SUCCESS_CODE,
} from './constants';

const handleResponse = ({ response }) => response;

const handleBlob = ({ responseType, response }) => {
  if (responseType !== 'blob') {
    throw new Error('Ha ocurrido un error procesando tu petición.');
  }
  return response;
};

const handleData = (response = {}) => {
  if (isPlainObject(response) && isNumber(response.codigo)) {
    if (response.codigo !== SUCCESS_CODE) {
      throw new AppError(response.codigo, response.descripcion);
    }
    return response;
  }
  throw new Error('El servicio ha respondido con un formato inválido.');
};

const retryStrategy = errors => (
  errors.scan((acc, error) => {
    switch (error.status) {
      case 0: {
        if (acc > AJAX_RETRY_LIMIT) {
          throw new AppError(error.status, 'Verifique su conexión a los servicios de la aplicación.');
        }
        return acc + 1;
      }
      default:
        throw error;
    }
  }, 1).delay(AJAX_RETRY_DELAY)
);

export default (options = {}) => {
  const {
    baseUrl = process.env.REACT_APP_API_URL,
    body,
    endpoint = '',
    method = 'GET',
    token = true,
    queryParams = null,
    responseType = 'json',
    timeout = AJAX_TIMEOUT,
  } = options;
  const headers = {};
  const query = queryParams ? `?${queryString.stringify(queryParams)}` : '';
  if (token) {
    headers['Auth-Token'] = JWT.get();
  }
  if (method !== 'GET' && responseType === 'json' && !(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  let ajaxObservable = ajax({
    body,
    method,
    url: `${baseUrl}${endpoint}${query}`,
    responseType,
    timeout,
    headers,
  });
  if (responseType === 'blob') {
    ajaxObservable = ajaxObservable.map(handleBlob);
  } else {
    ajaxObservable = ajaxObservable.map(handleResponse).map(handleData);
  }
  return ajaxObservable.retryWhen(retryStrategy);
};



// WEBPACK FOOTER //
// ./src/shared/ajax.js